// @generated
// This file was automatically generated and should not be edited.
// Run `dev generate pipeline-frontend` to regenerate.

/* eslint-disable unused-imports/no-unused-imports */

// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {ColumnTypeValidationFlag} from 'data-frames/util/validateColumnType';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {LeafType} from 'data-types/benchling-type-def/BenchlingTypeDef';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {PipelineStepDataKind, PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {PipelineStepShape} from 'pipelines/StepShapeUtils';

export const CONVERT_TO_ASM_STEP_SHAPES = [
  {
    stepType: PipelineStepType.CONVERT_TO_ASM,
    isDeprecated: false,
    version: 0,
    inputDataShapes: {
      'Input files': {
        systemName: 'Input files',
        displayName: 'Input files',
        kind: PipelineStepDataKind.FILE,
        isMulti: true,
        isRequired: true
      }
    },
    outputDataShapes: {
      'Output files': {
        systemName: 'Output files',
        displayName: 'Output files',
        kind: PipelineStepDataKind.FILE,
        isMulti: true,
        isRequired: true
      }
    },
    config: {
      asmVendor: {
        kind: 'enum',
        required: false,
        choices: [
          {
            value: 'AGILENT_GEN5',
            displayName: 'Agilent Gen5'
          },
          {
            value: 'AGILENT_GEN5_IMAGE',
            displayName: 'Agilent Gen5 Image'
          },
          {
            value: 'AGILENT_OPENLAB_CDS',
            displayName: 'Agilent OpenLab CDS'
          },
          {
            value: 'AGILENT_TAPESTATION_ANALYSIS',
            displayName: 'Agilent TapeStation Analysis'
          },
          {
            value: 'APPBIO_ABSOLUTE_Q',
            displayName: 'AppBio AbsoluteQ'
          },
          {
            value: 'APPBIO_QUANTSTUDIO',
            displayName: 'AppBio QuantStudio RT-PCR'
          },
          {
            value: 'APPBIO_QUANTSTUDIO_DESIGNANDANALYSIS',
            displayName: 'AppBio QuantStudio Design & Analysis'
          },
          {
            value: 'BENCHLING_EMPOWER',
            displayName: 'Benchling Waters Empower Adapter'
          },
          {
            value: 'BECKMAN_COULTER_BIOMEK',
            displayName: 'Beckman Coulter Biomek'
          },
          {
            value: 'BECKMAN_ECHO_CHERRY_PICK',
            displayName: 'Beckman Echo Cherry Pick'
          },
          {
            value: 'BECKMAN_ECHO_PLATE_REFORMAT',
            displayName: 'Beckman Echo Plate Reformat'
          },
          {
            value: 'BMG_LABTECH_SMART_CONTROL',
            displayName: 'BMG Labtech SMART Control'
          },
          {
            value: 'BMG_MARS',
            displayName: 'BMG Labtech MARS'
          },
          {
            value: 'BECKMAN_PHARMSPEC',
            displayName: 'Beckman Coulter PharmSpec'
          },
          {
            value: 'BECKMAN_VI_CELL_BLU',
            displayName: 'Beckman Coulter Vi-Cell BLU'
          },
          {
            value: 'BECKMAN_VI_CELL_XR',
            displayName: 'Beckman Coulter Vi-Cell XR'
          },
          {
            value: 'BD_BIOSCIENCES_FACSDIVA',
            displayName: 'BD Biosciences FACSDiva'
          },
          {
            value: 'BIORAD_BIOPLEX',
            displayName: 'Bio-Rad Bio-Plex Manager'
          },
          {
            value: 'CFXMAESTRO',
            displayName: 'Bio-Rad CFX Maestro'
          },
          {
            value: 'CHEMOMETEC_NC_VIEW',
            displayName: 'ChemoMetec NC View'
          },
          {
            value: 'CHEMOMETEC_NUCLEOVIEW',
            displayName: 'ChemoMetec Nucleoview'
          },
          {
            value: 'CTL_IMMUNOSPOT',
            displayName: 'CTL ImmunoSpot'
          },
          {
            value: 'CYTIVA_BIACORE_INSIGHT',
            displayName: 'Cytiva Biacore Insight'
          },
          {
            value: 'CYTIVA_BIACORE_T200_CONTROL',
            displayName: 'Cytiva Biacore T200 Control'
          },
          {
            value: 'CYTIVA_BIACORE_T200_EVALUATION',
            displayName: 'Cytiva Biacore T200 Evaluation'
          },
          {
            value: 'CYTIVA_UNICORN',
            displayName: 'Cytiva Unicorn'
          },
          {
            value: 'FLOWJO',
            displayName: 'FlowJo'
          },
          {
            value: 'LUMINEX_INTELLIFLEX',
            displayName: 'Luminex INTELLIFLEX'
          },
          {
            value: 'LUMINEX_XPONENT',
            displayName: 'Luminex xPONENT'
          },
          {
            value: 'MABTECH_APEX',
            displayName: 'Mabtech Apex'
          },
          {
            value: 'METHODICAL_MIND',
            displayName: 'MSD Methodical Mind'
          },
          {
            value: 'MOLDEV_SOFTMAX_PRO',
            displayName: 'Molecular Devices SoftMax Pro'
          },
          {
            value: 'MSD_WORKBENCH',
            displayName: 'MSD Discovery Workbench'
          },
          {
            value: 'REVVITY_MATRIX',
            displayName: 'Revvity Matrix'
          },
          {
            value: 'NOVABIO_FLEX2',
            displayName: 'NovaBio Flex2'
          },
          {
            value: 'PERKIN_ELMER_ENVISION',
            displayName: 'PerkinElmer Envision'
          },
          {
            value: 'QIACUITY_DPCR',
            displayName: 'Qiacuity dPCR'
          },
          {
            value: 'REVVITY_KALEIDO',
            displayName: 'Revvity Kaleido'
          },
          {
            value: 'ROCHE_CEDEX_BIOHT',
            displayName: 'Roche Cedex BioHT'
          },
          {
            value: 'ROCHE_CEDEX_HIRES',
            displayName: 'Roche Cedex HiRes'
          },
          {
            value: 'TECAN_MAGELLAN',
            displayName: 'Tecan Magellan'
          },
          {
            value: 'BENCHLING_CHROMELEON',
            displayName: 'Benchling Thermo Fisher Scientific Chromeleon'
          },
          {
            value: 'THERMO_FISHER_GENESYS30',
            displayName: 'Thermo Fisher Scientific Genesys30'
          },
          {
            value: 'THERMO_FISHER_GENESYS_ON_BOARD',
            displayName: 'Thermo Fisher Scientific Genesys On-Board'
          },
          {
            value: 'THERMO_FISHER_NANODROP_8000',
            displayName: 'Thermo Fisher Scientific NanoDrop 8000'
          },
          {
            value: 'THERMO_FISHER_NANODROP_EIGHT',
            displayName: 'Thermo Fisher Scientific NanoDrop Eight'
          },
          {
            value: 'THERMO_FISHER_NANODROP_ONE',
            displayName: 'Thermo Fisher Scientific Nanodrop One'
          },
          {
            value: 'THERMO_FISHER_QUBIT4',
            displayName: 'Thermo Fisher Scientific Qubit 4'
          },
          {
            value: 'THERMO_FISHER_QUBIT_FLEX',
            displayName: 'Thermo Fisher Scientific Qubit Flex'
          },
          {
            value: 'THERMO_FISHER_VISIONLITE',
            displayName: 'Thermo Fisher Scientific VISIONlite'
          },
          {
            value: 'THERMO_SKANIT',
            displayName: 'Thermo Fisher Scientific SkanIt'
          },
          {
            value: 'UNCHAINED_LABS_LUNATIC',
            displayName: 'Unchained Labs Lunatic & Stunner'
          }
        ]
      },
      transformType: {
        kind: 'enum',
        required: false,
        choices: [
          {
            value: 'ALLOTROPE',
            displayName: 'Allotrope'
          },
          {
            value: 'ANALYTE',
            displayName: 'Analyte'
          },
          {
            value: 'COMPENSATION',
            displayName: 'Compensation'
          },
          {
            value: 'DATACUBE',
            displayName: 'Datacube'
          },
          {
            value: 'FRACTIONS',
            displayName: 'Fractions'
          },
          {
            value: 'GROUP',
            displayName: 'Group'
          },
          {
            value: 'INJECTIONS',
            displayName: 'Injections'
          },
          {
            value: 'LOG',
            displayName: 'Log'
          },
          {
            value: 'MEASUREMENT',
            displayName: 'Measurement'
          },
          {
            value: 'MEASUREMENT_SEPARATE_UNIT_COLUMN',
            displayName: 'Measurement Separate Unit Column'
          },
          {
            value: 'ORIGINAL',
            displayName: 'Original'
          },
          {
            value: 'PEAKS',
            displayName: 'Peaks'
          },
          {
            value: 'POPULATION',
            displayName: 'Population'
          },
          {
            value: 'REGION',
            displayName: 'Region'
          },
          {
            value: 'REPORT_POINT',
            displayName: 'Report Point'
          },
          {
            value: 'REPORT',
            displayName: 'Report'
          },
          {
            value: 'SAMPLE',
            displayName: 'Sample'
          },
          {
            value: 'SAMPLE_SEPARATE_UNIT_COLUMN',
            displayName: 'Sample Separate Unit Column'
          },
          {
            value: 'MEASUREMENT_LOG',
            displayName: 'Measurement Log'
          },
          {
            value: 'TIMESERIES',
            displayName: 'Timeseries'
          },
          {
            value: 'TIMESERIES_NULL_ERRORS',
            displayName: 'Timeseries Null Errors'
          },
          {
            value: 'TIMESERIES_PATH_GROUPED',
            displayName: 'Timeseries Path Grouped'
          },
          {
            value: 'TIMESERIES_PATH_GROUPED_NULL_ERRORS',
            displayName: 'Timeseries Path Grouped Null Errors'
          },
          {
            value: 'WELL',
            displayName: 'Well'
          }
        ]
      },
      dataLocale: {
        kind: 'enum',
        required: false,
        choices: [
          {
            value: 'bnch-12hr',
            displayName: 'International (12 hour)'
          },
          {
            value: 'bnch-24hr',
            displayName: 'International (24 hour)'
          },
          {
            value: 'af',
            displayName: 'Afrikaans'
          },
          {
            value: 'af-NA',
            displayName: 'Afrikaans (Namibia)'
          },
          {
            value: 'af-ZA',
            displayName: 'Afrikaans (South Africa)'
          },
          {
            value: 'ak',
            displayName: 'Akan'
          },
          {
            value: 'sq',
            displayName: 'Albanian'
          },
          {
            value: 'sq-AL',
            displayName: 'Albanian (Regional)'
          },
          {
            value: 'ar',
            displayName: 'Arabic'
          },
          {
            value: 'ar-MA',
            displayName: 'Arabic (Morocco)'
          },
          {
            value: 'ar-AR',
            displayName: 'Arabic (Regional)'
          },
          {
            value: 'ar-SA',
            displayName: 'Arabic (Saudi Arabia)'
          },
          {
            value: 'hy-AM',
            displayName: 'Armenian'
          },
          {
            value: 'az',
            displayName: 'Azerbaijani'
          },
          {
            value: 'az-AZ',
            displayName: 'Azerbaijani (Regional)'
          },
          {
            value: 'eu',
            displayName: 'Basque'
          },
          {
            value: 'eu-ES',
            displayName: 'Basque (Regional)'
          },
          {
            value: 'be-BY',
            displayName: 'Belarusian'
          },
          {
            value: 'bn',
            displayName: 'Bengali'
          },
          {
            value: 'bn-BD',
            displayName: 'Bengali (Bangladesh)'
          },
          {
            value: 'bn-IN',
            displayName: 'Bengali (India)'
          },
          {
            value: 'bs-BA',
            displayName: 'Bosnian'
          },
          {
            value: 'bg',
            displayName: 'Bulgarian'
          },
          {
            value: 'bg-BG',
            displayName: 'Bulgarian (Regional)'
          },
          {
            value: 'my',
            displayName: 'Burmese'
          },
          {
            value: 'ca',
            displayName: 'Catalan'
          },
          {
            value: 'ca-ES',
            displayName: 'Catalan (Regional)'
          },
          {
            value: 'zh',
            displayName: 'Chinese'
          },
          {
            value: 'zh-Hans',
            displayName: 'Chinese Simplified'
          },
          {
            value: 'zh-CN',
            displayName: 'Chinese Simplified (China)'
          },
          {
            value: 'zh-SG',
            displayName: 'Chinese Simplified (Singapore)'
          },
          {
            value: 'zh-Hant',
            displayName: 'Chinese Traditional'
          },
          {
            value: 'zh-HK',
            displayName: 'Chinese Traditional (Hong Kong)'
          },
          {
            value: 'zh-TW',
            displayName: 'Chinese Traditional (Taiwan)'
          },
          {
            value: 'hr',
            displayName: 'Croatian'
          },
          {
            value: 'hr-HR',
            displayName: 'Croatian (Regional)'
          },
          {
            value: 'cs',
            displayName: 'Czech'
          },
          {
            value: 'cs-CZ',
            displayName: 'Czech (Regional)'
          },
          {
            value: 'da',
            displayName: 'Danish'
          },
          {
            value: 'da-DK',
            displayName: 'Danish (Regional)'
          },
          {
            value: 'nl',
            displayName: 'Dutch'
          },
          {
            value: 'nl-BE',
            displayName: 'Dutch (Belgium)'
          },
          {
            value: 'nl-NL',
            displayName: 'Dutch (Netherlands)'
          },
          {
            value: 'en',
            displayName: 'English'
          },
          {
            value: 'en-AU',
            displayName: 'English (Australia)'
          },
          {
            value: 'en-CA',
            displayName: 'English (Canada)'
          },
          {
            value: 'en-IN',
            displayName: 'English (India)'
          },
          {
            value: 'en-IE',
            displayName: 'English (Ireland)'
          },
          {
            value: 'en-ZA',
            displayName: 'English (South Africa)'
          },
          {
            value: 'en-GB',
            displayName: 'English (UK)'
          },
          {
            value: 'en-US',
            displayName: 'English (US)'
          },
          {
            value: 'eo',
            displayName: 'Esperanto'
          },
          {
            value: 'eo-EO',
            displayName: 'Esperanto (Regional)'
          },
          {
            value: 'et',
            displayName: 'Estonian'
          },
          {
            value: 'et-EE',
            displayName: 'Estonian (Estonia)'
          },
          {
            value: 'fo-FO',
            displayName: 'Faroese'
          },
          {
            value: 'tl',
            displayName: 'Filipino'
          },
          {
            value: 'tl-PH',
            displayName: 'Filipino (Regional)'
          },
          {
            value: 'fi',
            displayName: 'Finnish'
          },
          {
            value: 'fi-FI',
            displayName: 'Finnish (Regional)'
          },
          {
            value: 'fr',
            displayName: 'French'
          },
          {
            value: 'fr-BE',
            displayName: 'French (Belgium)'
          },
          {
            value: 'fr-CA',
            displayName: 'French (Canada)'
          },
          {
            value: 'fr-FR',
            displayName: 'French (France)'
          },
          {
            value: 'fr-CH',
            displayName: 'French (Switzerland)'
          },
          {
            value: 'fy-NL',
            displayName: 'Frisian (West)'
          },
          {
            value: 'ff',
            displayName: 'Fulah'
          },
          {
            value: 'gl',
            displayName: 'Galician'
          },
          {
            value: 'gl-ES',
            displayName: 'Galician (Regional)'
          },
          {
            value: 'ka-GE',
            displayName: 'Georgian'
          },
          {
            value: 'de',
            displayName: 'German'
          },
          {
            value: 'de-AT',
            displayName: 'German (Austria)'
          },
          {
            value: 'de-DE',
            displayName: 'German (Germany)'
          },
          {
            value: 'de-CH',
            displayName: 'German (Switzerland)'
          },
          {
            value: 'el',
            displayName: 'Greek'
          },
          {
            value: 'el-GR',
            displayName: 'Greek (Greece)'
          },
          {
            value: 'gu-IN',
            displayName: 'Gujarati'
          },
          {
            value: 'he',
            displayName: 'Hebrew'
          },
          {
            value: 'he-IL',
            displayName: 'Hebrew (Regional)'
          },
          {
            value: 'hi',
            displayName: 'Hindi'
          },
          {
            value: 'hi-IN',
            displayName: 'Hindi (Regional)'
          },
          {
            value: 'hu',
            displayName: 'Hungarian'
          },
          {
            value: 'hu-HU',
            displayName: 'Hungarian (Regional)'
          },
          {
            value: 'is',
            displayName: 'Icelandic'
          },
          {
            value: 'is-IS',
            displayName: 'Icelandic (Iceland)'
          },
          {
            value: 'id',
            displayName: 'Indonesian'
          },
          {
            value: 'id-ID',
            displayName: 'Indonesian (Regional)'
          },
          {
            value: 'ga',
            displayName: 'Irish'
          },
          {
            value: 'ga-IE',
            displayName: 'Irish (Gaelic)'
          },
          {
            value: 'it',
            displayName: 'Italian'
          },
          {
            value: 'it-IT',
            displayName: 'Italian (Regional)'
          },
          {
            value: 'ja',
            displayName: 'Japanese'
          },
          {
            value: 'ja-JP',
            displayName: 'Japanese (Regional)'
          },
          {
            value: 'jv-ID',
            displayName: 'Javanese'
          },
          {
            value: 'kab',
            displayName: 'Kabyle'
          },
          {
            value: 'kn',
            displayName: 'Kannada'
          },
          {
            value: 'kn-IN',
            displayName: 'Kannada (India)'
          },
          {
            value: 'kk-KZ',
            displayName: 'Kazakh'
          },
          {
            value: 'km',
            displayName: 'Khmer'
          },
          {
            value: 'km-KH',
            displayName: 'Khmer (Regional)'
          },
          {
            value: 'ko',
            displayName: 'Korean'
          },
          {
            value: 'ko-KR',
            displayName: 'Korean (Korea)'
          },
          {
            value: 'ku-TR',
            displayName: 'Kurdish'
          },
          {
            value: 'la',
            displayName: 'Latin'
          },
          {
            value: 'lv',
            displayName: 'Latvian'
          },
          {
            value: 'lv-LV',
            displayName: 'Latvian (Regional)'
          },
          {
            value: 'lt',
            displayName: 'Lithuanian'
          },
          {
            value: 'lt-LT',
            displayName: 'Lithuanian (Regional)'
          },
          {
            value: 'dsb',
            displayName: 'Lower Sorbian'
          },
          {
            value: 'lb',
            displayName: 'Luxembourgish'
          },
          {
            value: 'mk',
            displayName: 'Macedonian'
          },
          {
            value: 'mk-MK',
            displayName: 'Macedonian (Macedonian)'
          },
          {
            value: 'mai',
            displayName: 'Maithili'
          },
          {
            value: 'mg-MG',
            displayName: 'Malagasy'
          },
          {
            value: 'ms',
            displayName: 'Malay'
          },
          {
            value: 'ms-MY',
            displayName: 'Malay (Regional)'
          },
          {
            value: 'ml',
            displayName: 'Malayalam'
          },
          {
            value: 'ml-IN',
            displayName: 'Malayalam (Regional)'
          },
          {
            value: 'mt',
            displayName: 'Maltese'
          },
          {
            value: 'mt-MT',
            displayName: 'Maltese (Regional)'
          },
          {
            value: 'mr',
            displayName: 'Marathi'
          },
          {
            value: 'mr-IN',
            displayName: 'Marathi (Regional)'
          },
          {
            value: 'mn-MN',
            displayName: 'Mongolian'
          },
          {
            value: 'ne',
            displayName: 'Nepali'
          },
          {
            value: 'ne-NP',
            displayName: 'Nepali (Regional)'
          },
          {
            value: 'se-NO',
            displayName: 'Northern S\u00e1mi'
          },
          {
            value: 'no',
            displayName: 'Norwegian'
          },
          {
            value: 'nb',
            displayName: 'Norwegian (bokmal)'
          },
          {
            value: 'nb-NO',
            displayName: 'Norwegian (bokmal) (Regional)'
          },
          {
            value: 'nn-NO',
            displayName: 'Norwegian (nynorsk)'
          },
          {
            value: 'or-IN',
            displayName: 'Oriya'
          },
          {
            value: 'ps-AF',
            displayName: 'Pashto'
          },
          {
            value: 'fa',
            displayName: 'Persian'
          },
          {
            value: 'fa-IR',
            displayName: 'Persian (Regional)'
          },
          {
            value: 'pl',
            displayName: 'Polish'
          },
          {
            value: 'pl-PL',
            displayName: 'Polish (Regional)'
          },
          {
            value: 'pt',
            displayName: 'Portuguese'
          },
          {
            value: 'pt-BR',
            displayName: 'Portuguese (Brazil)'
          },
          {
            value: 'pt-PT',
            displayName: 'Portuguese (Portugal)'
          },
          {
            value: 'pa',
            displayName: 'Punjabi'
          },
          {
            value: 'pa-IN',
            displayName: 'Punjabi (India)'
          },
          {
            value: 'qu-PE',
            displayName: 'Quechua'
          },
          {
            value: 'ro',
            displayName: 'Romanian'
          },
          {
            value: 'ro-RO',
            displayName: 'Romanian (Regional)'
          },
          {
            value: 'rm-CH',
            displayName: 'Romansh'
          },
          {
            value: 'ru',
            displayName: 'Russian'
          },
          {
            value: 'ru-RU',
            displayName: 'Russian (Regional)'
          },
          {
            value: 'sa-IN',
            displayName: 'Sanskrit'
          },
          {
            value: 'sr',
            displayName: 'Serbian'
          },
          {
            value: 'sr-RS',
            displayName: 'Serbian (Serbia)'
          },
          {
            value: 'si-LK',
            displayName: 'Sinhala (Sri Lanka)'
          },
          {
            value: 'sk',
            displayName: 'Slovak'
          },
          {
            value: 'sk-SK',
            displayName: 'Slovak (Slovakia)'
          },
          {
            value: 'sl',
            displayName: 'Slovenian'
          },
          {
            value: 'sl-SI',
            displayName: 'Slovenian (Regional)'
          },
          {
            value: 'so-SO',
            displayName: 'Somali'
          },
          {
            value: 'es',
            displayName: 'Spanish'
          },
          {
            value: 'es-AR',
            displayName: 'Spanish (Argentina)'
          },
          {
            value: 'es-CL',
            displayName: 'Spanish (Chile)'
          },
          {
            value: 'es-CO',
            displayName: 'Spanish (Colombia)'
          },
          {
            value: 'es-EC',
            displayName: 'Spanish (Ecuador)'
          },
          {
            value: 'es-419',
            displayName: 'Spanish (Latin America) (es-419)'
          },
          {
            value: 'es-LA',
            displayName: 'Spanish (Latin America) (es-LA)'
          },
          {
            value: 'es-MX',
            displayName: 'Spanish (Mexico)'
          },
          {
            value: 'es-NI',
            displayName: 'Spanish (Nicaragua)'
          },
          {
            value: 'es-ES',
            displayName: 'Spanish (Spain)'
          },
          {
            value: 'es-US',
            displayName: 'Spanish (United States)'
          },
          {
            value: 'es-VE',
            displayName: 'Spanish (Venezuela)'
          },
          {
            value: 'su',
            displayName: 'Sundanese'
          },
          {
            value: 'sw',
            displayName: 'Swahili'
          },
          {
            value: 'sw-KE',
            displayName: 'Swahili (Kenya)'
          },
          {
            value: 'sv',
            displayName: 'Swedish'
          },
          {
            value: 'sv-SE',
            displayName: 'Swedish (Regional)'
          },
          {
            value: 'tg',
            displayName: 'Tajik'
          },
          {
            value: 'tg-TJ',
            displayName: 'Tajik (Regional)'
          },
          {
            value: 'ta',
            displayName: 'Tamil'
          },
          {
            value: 'ta-IN',
            displayName: 'Tamil (Regional)'
          },
          {
            value: 'tt-RU',
            displayName: 'Tatar'
          },
          {
            value: 'te',
            displayName: 'Telugu'
          },
          {
            value: 'te-IN',
            displayName: 'Telugu (Regional)'
          },
          {
            value: 'th',
            displayName: 'Thai'
          },
          {
            value: 'th-TH',
            displayName: 'Thai (Thailand)'
          },
          {
            value: 'tr',
            displayName: 'Turkish'
          },
          {
            value: 'tr-TR',
            displayName: 'Turkish (Regional)'
          },
          {
            value: 'uk',
            displayName: 'Ukrainian'
          },
          {
            value: 'uk-UA',
            displayName: 'Ukrainian (Regional)'
          },
          {
            value: 'hsb',
            displayName: 'Upper Sorbian'
          },
          {
            value: 'ur',
            displayName: 'Urdu'
          },
          {
            value: 'ur-PK',
            displayName: 'Urdu (Regional)'
          },
          {
            value: 'uz',
            displayName: 'Uzbek'
          },
          {
            value: 'uz-UZ',
            displayName: 'Uzbek (Regional)'
          },
          {
            value: 'vi',
            displayName: 'Vietnamese'
          },
          {
            value: 'vi-VN',
            displayName: 'Vietnamese (Regional)'
          },
          {
            value: 'cy',
            displayName: 'Welsh'
          },
          {
            value: 'cy-GB',
            displayName: 'Welsh (Regional)'
          },
          {
            value: 'xh-ZA',
            displayName: 'Xhosa'
          },
          {
            value: 'yi',
            displayName: 'Yiddish'
          },
          {
            value: 'zu-ZA',
            displayName: 'Zulu'
          }
        ]
      }
    }
  }
] as const satisfies ReadonlyArray<PipelineStepShape>;
